import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { ToastService } from '@hutsix/ngxh6';
import { DefaultFormComponent, FormServiceInterface } from '@hutsix/ngxh6';
import { CSPUserService } from '../../../../_shared/services/user/cdrc-csp-user.service';

@Component({
    selector: 'app-scheduled-service-form',
    templateUrl: './scheduled-service-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ScheduledServiceFormComponent extends DefaultFormComponent {
    Object = Object; // Expose Object to template

    constructor(
        @Inject('FormService') public formService: FormServiceInterface,
        @Inject('UserService') public userService: CSPUserService,
        public location: Location,
        public cdRef: ChangeDetectorRef,
        public toastr: ToastService,
    ) {
        super(formService, userService, location, cdRef);
    }
}
